import SeleccionCuentaSkeleton from './components/SeleccionCuentaSkeleton.jsx'
import { useRolSeleccionCuenta } from './hooks/useRolSeleccionCuenta.js'
import SeleccionCuentaAdminArt from './views/SeleccionCuentaAdminArt.jsx'
import SeleccionCuentaUsuario from './views/SeleccionCuentaUsuario.jsx'

/**
 * Una sola ruta para todos los perfiles: el PHP redirige siempre a
 * `/seleccion-cuenta` y la vista se elige acá según el rol.
 * - Admin ART/HyS → buscador sobre todas las empresas (PBI #80676).
 * - Resto → grilla con las cuentas asociadas (PBI #80498).
 */
export default function SeleccionCuenta() {
  const { esAdminARToHyS, isLoading } = useRolSeleccionCuenta()

  if (isLoading) return <SeleccionCuentaSkeleton />

  return esAdminARToHyS ? <SeleccionCuentaAdminArt /> : <SeleccionCuentaUsuario />
}
